import React, { Component } from "react";
import { Tabs } from "antd";

const TabPane = Tabs.TabPane;

function callback(key) {
  console.log(key);
}

export const InfoTabsComponent = props => {
  const custommappings = props.custommappings;
  const artworkItems = custommappings.filter(item => item.type === "Artwork");
  const artworkTypeItems = custommappings.filter(item => item.type === "ArtworkType");
  const proofLinkItems = custommappings.filter(
    item => item.type === "Prooflink"
  );
  return (
    <Tabs className="info-tabs" defaultActiveKey="1" onChange={callback}>
      <TabPane tab="Artwork" key="1">
        <ul>
          <li>
            <span>#</span>
            <span>Source</span>
            <span>Destination</span>
          </li>
          {artworkItems &&
            artworkItems.map((item,index) => (
              <li key={index}>
                <span>{item.id}</span>
                <span>{item.source}</span> <span>{item.destination}</span>
              </li>
            ))}
        </ul>
      </TabPane>
        <TabPane tab="ArtworkType" key="2">
          <ul>
            <li>
              <span>#</span>
              <span>Source</span>
              <span>Destination</span>
            </li>
            {artworkTypeItems &&
              artworkTypeItems.map((item,index) => (
                <li key={index}>
                  <span>{item.id}</span>
                  <span>{item.source}</span> <span>{item.destination}</span>
                </li>
              ))}
          </ul>
        </TabPane>
      <TabPane tab="Prooflink" key="3">
        <ul>
          <li>
            <span>#</span>
            <span>Source</span>
            <span>Destination</span>
          </li>
          {proofLinkItems &&
            proofLinkItems.map((item,index) => (
              <li key={index}>
                <span>{item.id}</span>
                <span>{item.source}</span> <span>{item.destination}</span>
              </li>
            ))}
        </ul>
      </TabPane>
    </Tabs>
  );
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/InfoTabs/InfoTabsComponent.js